(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-box-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mc-box-comparison')) {
    customElements.define('mc-box-comparison', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        this.addEventListener('click', event => {
          const tab = event.target.closest('[data-compare-tab]');
          if (!tab || !this.contains(tab)) return;
          this.querySelectorAll('[data-compare-tab]').forEach(button => button.setAttribute('aria-pressed', String(button === tab)));
          this.querySelectorAll('[data-compare-panel]').forEach(panel => panel.hidden = panel.dataset.comparePanel !== tab.dataset.compareTab);
        }, { signal: this.events.signal });
      }
      disconnectedCallback() { this.events?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-hero-slider"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mc-hero-slider')){
 customElements.define('mc-hero-slider',class extends HTMLElement{
  connectedCallback(){
   if(this._events)return;
   this._events=new AbortController();
   this._slides=[...this.querySelectorAll('[data-hero-slide]')];
   this._dots=[...this.querySelectorAll('[data-hero-dot]')];
   this._duration=Number(this.dataset.interval)||6000;
   this._index=0;this._inView=true;this._autoStopped=false;
   this._starting=new WeakSet();this._retryCounts=new WeakMap();
   this._reduced=matchMedia('(prefers-reduced-motion:reduce)');
   this._mobile=matchMedia('(max-width:700px)');
   this._paused=this.dataset.autoplay==='false'||this._reduced.matches;
   const options={signal:this._events.signal};
   this._slides.forEach(slide=>this._bindFilm(slide));
   this._show(0);this._prepareMedia();
   this.addEventListener('click',event=>{
    const target=event.target.closest('button');if(!target)return;
    if(target.matches('[data-hero-dot]'))this._select(Number(target.dataset.heroDot));
   },options);
   this.addEventListener('keydown',event=>{
    if(event.key!=='ArrowLeft'&&event.key!=='ArrowRight')return;
    event.preventDefault();this._select(this._index+(event.key==='ArrowRight'?1:-1));
   },options);
   this.addEventListener('pointerdown',event=>{
    this._stopAuto();
    if(!event.target.closest('a,button,input,select,textarea'))this._touch={x:event.clientX,y:event.clientY};
   },options);
   this.addEventListener('pointerup',event=>{
    if(!this._touch)return;
    const dx=event.clientX-this._touch.x,dy=event.clientY-this._touch.y;this._touch=null;
    if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy))this._select(this._index+(dx<0?1:-1));
   },options);
   this.addEventListener('pointercancel',()=>{this._touch=null;},options);
   this.addEventListener('focusin',()=>this._stopAuto(),options);
   this._mobile.addEventListener('change',()=>this._chooseMedia(),options);
   this._reduced.addEventListener('change',()=>{
    this._paused=this.dataset.autoplay==='false'||this._reduced.matches;
    this._chooseMedia();this._restart();
   },options);
   document.addEventListener('visibilitychange',()=>{if(!document.hidden)this._recoverFilms();this._restart();},options);
   // iOS grants media activation on touchend/click, not on touch pointerdown.
   const recoverFromGesture=event=>{if(event.isTrusted)this._recoverFilms(true);};
   document.addEventListener('touchend',recoverFromGesture,{...options,passive:true});
   document.addEventListener('click',recoverFromGesture,options);
   document.addEventListener('keydown',recoverFromGesture,options);
   window.addEventListener('online',()=>this._recoverFilms(),options);
   window.addEventListener('pageshow',()=>{this._recoverFilms();this._restart();},options);
   document.addEventListener('shopify:block:select',event=>{
    const index=this._slides.findIndex(slide=>slide.contains(event.target));
    if(index>=0)this._select(index);
   },options);
   this._observer=new IntersectionObserver(entries=>{
    this._inView=entries[0].isIntersecting;this._restart();
   },{threshold:.2});
   this._observer.observe(this);this._restart();this._startVideoDebug();
  }
  _bindFilm(slide){
   const video=slide.querySelector('[data-hero-film]');if(!video)return;
   video.loop=false;video.muted=true;video.defaultMuted=true;video.volume=0;video.playsInline=true;
   // The slider owns playback; the HTML autoplay hint must not run hidden slides.
   video.autoplay=!this._paused&&!this._reduced.matches&&!navigator.connection?.saveData&&slide.classList.contains('is-active');
   const options={signal:this._events.signal};
   video.addEventListener('playing',()=>{
    clearTimeout(this._stallTimer);delete video.dataset.failed;
    video.dataset.mcVideoState='playing';
    video.parentElement.classList.remove('is-static');video.classList.add('is-ready');this._restart();
   },options);
   video.addEventListener('ended',()=>{
    clearTimeout(this._stallTimer);
    if(slide.classList.contains('is-active'))this._restart();
   },options);
   video.addEventListener('error',()=>this._filmFallback(video,'media'),options);
   video.addEventListener('canplay',()=>{
    if(video.dataset.failed==='stall'){delete video.dataset.failed;video.parentElement.classList.remove('is-static');}
    this._restart();
   },options);
   video.addEventListener('waiting',()=>{
    if(!video.classList.contains('is-ready'))return;
    clearTimeout(this._stallTimer);
    this._stallTimer=setTimeout(()=>{if(!video.ended&&video.readyState<3&&slide.classList.contains('is-active'))this._filmFallback(video,'stall');},8000);
   },options);
  }
  _filmFallback(video,reason='playback',error){
   video.pause();video.classList.remove('is-ready');video.dataset.failed=reason;video.parentElement.classList.add('is-static');
   video.dataset.mcVideoState=reason;
   if(error)video.dataset.mcPlayError=error.name||'Error';
   if(error||video.error)console.warn('[MC Hero] Video fallback',{reason,name:error?.name,mediaCode:video.error?.code});
   clearTimeout(this._retryTimer);
   const count=this._retryCounts.get(video)||0;
   if(reason!=='blocked'&&count<2&&(!video.error||video.error.code===2)){
    this._retryCounts.set(video,count+1);
    this._retryTimer=setTimeout(()=>this._recoverFilms(),1500*(count+1));
   }
   this._restart();
  }
  _recoverFilms(userGesture=false){
   if(!this.isConnected||this._paused||this._reduced.matches||navigator.connection?.saveData||!this._inView||document.hidden)return;
   const video=this._slides[this._index]?.querySelector('[data-hero-film]');
   if(!video||!video.dataset.failed||(video.dataset.failed==='blocked'&&!userGesture))return;
   if(video.error&&video.error.code!==2)return;
   delete video.dataset.failed;video.parentElement.classList.remove('is-static');
   if(video.error)video.load();
   this._syncMedia();
  }
  _prepareMedia(){
   requestAnimationFrame(()=>{if(this.isConnected)this._chooseMedia();});
  }
  _chooseMedia(){
   const limited=this._paused||this._reduced.matches||navigator.connection?.saveData;
   this.querySelectorAll('[data-hero-film]').forEach(video=>{
    video.parentElement.classList.toggle('is-static',!!limited||!!video.dataset.failed);
    if(limited){video.pause();video.classList.remove('is-ready');return;}
    const src=this._mobile.matches?video.dataset.mobileSrc:video.dataset.desktopSrc;
    if(!src||video.getAttribute('src')===src)return;
    video.pause();video.classList.remove('is-ready');delete video.dataset.failed;video.parentElement.classList.remove('is-static');
    video.src=src;video.preload='auto';video.load();
   });
   this._restart();
  }
  _loadSlide(index){
   const slide=this._slides[index],template=slide?.querySelector('[data-hero-media-template]');
   if(!template)return;
   template.replaceWith(template.content.cloneNode(true));
   if(slide.querySelector('[data-hero-film]')){this._bindFilm(slide);this._chooseMedia();}
  }
  _show(next){
   clearTimeout(this._transitionTimer);
   const previous=this._slides[this._index];
   const moveFocus=previous?.contains(document.activeElement);
   const index=(next+this._slides.length)%this._slides.length;
   this._loadSlide(index);
   this._slides.forEach((slide,i)=>{
    const active=i===index;
    slide.classList.toggle('is-leaving',slide===previous&&!active);
    slide.classList.toggle('is-active',active);
    slide.setAttribute('aria-hidden',String(!active));slide.inert=!active;
   });
   if(index!==this._index){
    const film=this._slides[index].querySelector('[data-hero-film]');
    if(film?.readyState>0)film.currentTime=0;
   }
   this._index=index;
   this._dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===index)));
   if(moveFocus&&previous!==this._slides[index])this._dots[index]?.focus();
   this._transitionTimer=setTimeout(()=>{
    this._slides.forEach(slide=>{
     slide.classList.remove('is-leaving');
     const video=slide.querySelector('[data-hero-film]');
     if(video&&!slide.classList.contains('is-active')&&video.readyState>0&&getComputedStyle(slide).opacity==='0')video.currentTime=0;
    });
   },this._reduced.matches?0:320);
   this._syncMedia();
  }
  _syncMedia(){
   this._slides.forEach((slide,index)=>{
    const video=slide.querySelector('[data-hero-film]');if(!video)return;
    const canPlay=index===this._index&&!video.ended&&!!video.getAttribute('src')&&!video.dataset.failed&&!this._paused&&this._inView&&!document.hidden&&!this._reduced.matches&&!navigator.connection?.saveData;
    video.autoplay=!!canPlay;
    if(canPlay){
     video.muted=true;video.defaultMuted=true;video.volume=0;
     if(video.paused&&!this._starting.has(video)){
      this._starting.add(video);
      video.dataset.mcVideoState='starting';
      video.play().then(()=>{
       if(!this.isConnected||this._paused||!this._inView||document.hidden||index!==this._index||this._reduced.matches||navigator.connection?.saveData)video.pause();
      }).catch(error=>{
       if(error.name!=='AbortError'&&!this._paused&&this._inView&&!document.hidden&&index===this._index)this._filmFallback(video,error.name==='NotAllowedError'?'blocked':'playback',error);
      }).finally(()=>this._starting.delete(video));
     }
    }else video.pause();
   });
  }
  _startVideoDebug(){
   // Opt-in, local-only technical diagnostics. No tracking, storage or requests.
   if(new URLSearchParams(location.search).get('mc_video_debug')!=='1')return;
   this._debugPanel=document.createElement('pre');
   this._debugPanel.dataset.mcVideoDebug='20261017-1';
   this._debugPanel.style.cssText='position:fixed;z-index:2147483646;inset:auto 12px 82px;max-width:440px;max-height:38vh;margin:0;padding:12px;border:1px solid #9ee7be;border-radius:8px;background:#142018f5;color:#fff;font:11px/1.5 monospace;white-space:pre-wrap;overflow:hidden;pointer-events:none;text-align:left';
   document.body.append(this._debugPanel);
   const update=()=>{
    if(document.hidden)return;
    const grid=document.querySelector('mc-unboxings');
    const lines=['MC VIDEO DEBUG | 20261017-1',
     'motion='+this._reduced.matches+' saveData='+(navigator.connection?.saveData??'n/a'),
     'visibility='+document.visibilityState+' heroAutoplay='+this.dataset.autoplay,
     'heroSlide='+(this._index+1)+' inView='+this._inView,
     'grid='+(grid?.dataset.mcVideoState||'not-initialized')+' selected='+(grid?.dataset.mcSelected||'-')];
    document.querySelectorAll('[data-hero-film],mc-unboxings video').forEach((video,index)=>{
     if(index>0&&!video.getAttribute('src')&&index>1)return;
     lines.push((video.matches('[data-hero-film]')?'hero':'video'+index)+': src='+!!video.getAttribute('src')+' paused='+video.paused+' t='+video.currentTime.toFixed(1)+' ready='+video.readyState,
      '  state='+(video.dataset.mcVideoState||'-')+' reject='+(video.dataset.mcPlayError||'-')+' mediaError='+(video.error?.code||0));
    });
    this._debugPanel.textContent=lines.join('\n');
   };
   update();this._debugTimer=setInterval(update,500);
  }
  _stopAuto(){
   this._autoStopped=true;this.dataset.autoStopped='true';
   clearTimeout(this._timer);
  }
  _select(next){this._stopAuto();this._show(next);this._restart();}
  _advance(){
   if(this._paused||this._autoStopped||!this._inView||document.hidden){this._restart();return;}
   if(document.querySelector('dialog[open]')){this._timer=setTimeout(()=>this._advance(),500);return;}
   const film=this._slides[this._index].querySelector('[data-hero-film]');
   if(film?.classList.contains('is-ready')&&!film.ended){this._restart();return;}
   this._show(this._index+1);this._restart();
  }
  _restart(){
   clearTimeout(this._timer);clearTimeout(this._prepareTimer);this._syncMedia();
   if(this._paused||this._autoStopped||!this._inView||document.hidden||this._slides.length<2)return;
   const film=this._slides[this._index].querySelector('[data-hero-film]');
   const duration=film?(film.ended?0:film.classList.contains('is-ready')?Math.max(60,(film.duration-film.currentTime)*1000+100):Number(film.dataset.cycleMs)||3500):this._duration;
   this._prepareTimer=setTimeout(()=>this._loadSlide((this._index+1)%this._slides.length),Math.min(600,duration/2));
   this._timer=setTimeout(()=>this._advance(),duration);
  }
  disconnectedCallback(){
   this.querySelectorAll('[data-hero-film]').forEach(video=>video.pause());
   for(const timer of ['_timer','_prepareTimer','_transitionTimer','_stallTimer','_retryTimer'])clearTimeout(this[timer]);
   clearInterval(this._debugTimer);this._debugPanel?.remove();
   this._observer?.disconnect();this._events?.abort();this._events=null;
  }
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-hero-ticker"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mc-message-rotator'))customElements.define('mc-message-rotator',class extends HTMLElement{connectedCallback(){this.items=[...this.querySelectorAll('.mc-hero-ticker__item')];this.index=0;this.events=new AbortController();this.motion=matchMedia('(prefers-reduced-motion: reduce)');const update=()=>{clearInterval(this.timer);if(!document.hidden&&!this.motion.matches&&this.items.length>1)this.timer=setInterval(()=>{this.items[this.index].hidden=true;this.index=(this.index+1)%this.items.length;this.items[this.index].hidden=false;this.setAttribute('aria-label',this.items[this.index].textContent.trim())},5000)};document.addEventListener('visibilitychange',update,{signal:this.events.signal});this.motion.addEventListener('change',update,{signal:this.events.signal});update()}disconnectedCallback(){clearInterval(this.timer);this.events?.abort()}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-video-grid"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('mc-unboxings')) {
 customElements.define('mc-unboxings',class extends HTMLElement {
  connectedCallback() {
   if(this.events)return;
   this.events=new AbortController();const signal=this.events.signal;
   this.videos=[...this.querySelectorAll('video')];
   this.mobile=matchMedia('(max-width:749px)');this.motion=matchMedia('(prefers-reduced-motion:reduce)');
   this.selected=this.mobile.matches?0:Math.min(2,this.videos.length-1);
   this.visible=new Set();this.userStopped=false;this.manualSelection=false;this.blocked=false;this.blockedReason='';this.starting=null;this.retryCounts=new WeakMap();
   this.videos.forEach(video=>{
    video.muted=true;video.defaultMuted=true;video.volume=0;video.controls=false;video.playsInline=true;
    for(const name of ['play','pause','ended'])video.addEventListener(name,()=>this.paint(video),{signal});
    video.addEventListener('volumechange',()=>{if(!video.muted)video.muted=true;if(video.volume!==0)video.volume=0},{signal});
    video.addEventListener('playing',()=>{video.dataset.mcVideoState='playing';},{signal});
    video.addEventListener('error',()=>{video.dataset.mcVideoState='media-error';this.paint(video);},{signal});
    video.addEventListener('canplay',()=>{if(this.blockedReason==='transient')this.recover();},{signal});
   });
   this.addEventListener('click',event=>{
    const button=event.target.closest('.mc-unboxings-card button');if(!button)return;
    const video=button.parentElement.querySelector('video');this.selected=this.videos.indexOf(video);this.manualSelection=true;this.blocked=false;this.blockedReason='';
    if(!video.paused){this.userStopped=true;video.pause();this.paint(video);}
    else{this.userStopped=false;this.tryPlay(video);}
   },{signal});
   this.observer=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
     if(entry.isIntersecting&&entry.intersectionRatio>=.35)this.visible.add(entry.target);
     else this.visible.delete(entry.target);
     if(!entry.isIntersecting)entry.target.pause();
    });
    if(!this.visible.size&&this.blockedReason==='other-video'){this.blocked=false;this.blockedReason='';}
    this.sync();
   },{threshold:[0,.1,.35,.6,1]});
   this.videos.forEach(video=>this.observer.observe(video));
   this.posterObserver=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
     if(!entry.isIntersecting)return;
     const video=entry.target;
     if(!video.poster&&video.dataset.poster)video.poster=video.dataset.poster;
     this.posterObserver.unobserve(video);
    });
   },{rootMargin:'200px'});
   this.videos.forEach(video=>this.posterObserver.observe(video));
   this.mobile.addEventListener('change',()=>{
    if(!this.manualSelection)this.selected=this.mobile.matches?0:Math.min(2,this.videos.length-1);
    this.pauseAll();this.sync();
   },{signal});
   this.motion.addEventListener('change',()=>{this.pauseAll();this.sync();},{signal});
   document.addEventListener('visibilitychange',()=>{if(!document.hidden)this.recover();this.sync();},{signal});
   window.addEventListener('pageshow',()=>{this.recover();this.sync();},{signal});
   window.addEventListener('online',()=>this.recover(),{signal});
   const recoverFromGesture=event=>{
    if(!event.isTrusted||event.target.closest?.('.mc-unboxings-card button'))return;
    this.recover(true);
   };
   document.addEventListener('touchend',recoverFromGesture,{signal,passive:true});
   document.addEventListener('click',recoverFromGesture,{signal});
   document.addEventListener('keydown',recoverFromGesture,{signal});
   document.addEventListener('play',event=>{
    const video=event.target;
    if(!(video instanceof HTMLVideoElement)||this.videos.includes(video)||!video.closest('mc-unboxings,mc-unboxing-proof'))return;
    this.blocked=true;this.blockedReason='other-video';this.pauseAll();
   },{capture:true,signal});
   this.videos.forEach(video=>this.paint(video));this.sync();
  }
  paint(video) {
   const button=video.parentElement.querySelector('button');if(!button)return;
   const playing=!video.paused&&!video.ended;
   button.setAttribute('aria-pressed',String(playing));
   button.setAttribute('aria-label',playing?button.dataset.pauseLabel:button.dataset.playLabel);
  }
  pauseAll(except) {this.videos.forEach(video=>{if(video!==except)video.pause();});}
  sync() {
   if(!this.manualSelection&&!this.visible.has(this.videos[this.selected])&&this.visible.size){
    this.selected=this.videos.findIndex(video=>this.visible.has(video));
   }
   const video=this.videos[this.selected];
   const reduced=this.motion.matches||navigator.connection?.saveData;
   const reason=!video?'no-video':document.hidden?'hidden':this.userStopped?'user-paused':this.blocked?this.blockedReason||'blocked':!this.visible.has(video)?'offscreen':document.documentElement.classList.contains('mc-proof-is-open')?'dialog':reduced&&!this.manualSelection?'reduced-motion-or-data':'';
   this.dataset.mcSelected=String(this.selected+1);this.dataset.mcVideoState=reason||'eligible';
   if(reason){this.pauseAll();return;}
   this.tryPlay(video);
  }
  recover(userGesture=false) {
   if(!this.isConnected||document.hidden||this.userStopped||!this.blocked)return;
   if(this.blockedReason==='NotAllowedError'&&!userGesture)return;
   if(this.blockedReason==='other-video')return;
   const video=this.videos[this.selected];
   if(!video||!this.visible.has(video)||video.error&&video.error.code!==2)return;
   if((this.motion.matches||navigator.connection?.saveData)&&!this.manualSelection)return;
   this.blocked=false;this.blockedReason='';
   if(video.error)video.load();
   this.sync();
  }
  tryPlay(video) {
   if(!video.poster&&video.dataset.poster)video.poster=video.dataset.poster;
   if(this.starting===video||!video.paused)return;
   this.pauseAll(video);
   document.querySelectorAll('mc-unboxings video,mc-unboxing-proof video').forEach(other=>{if(other!==video)other.pause();});
   video.muted=true;video.defaultMuted=true;video.volume=0;video.controls=false;video.playsInline=true;
   if(!video.getAttribute('src'))video.src=this.mobile.matches?video.dataset.mobileSrc:video.dataset.desktopSrc;
   this.starting=video;video.dataset.mcVideoState='starting';
   video.play().then(()=>{
    if(!this.isConnected||document.hidden||this.userStopped||this.blocked||!this.visible.has(video)||this.videos[this.selected]!==video||document.documentElement.classList.contains('mc-proof-is-open'))video.pause();
    this.paint(video);
   }).catch(error=>{
    video.dataset.mcPlayError=error.name||'Error';
    if(error.name!=='AbortError'&&this.isConnected&&this.videos[this.selected]===video&&this.visible.has(video)&&!this.userStopped){
     this.blocked=true;this.blockedReason=error.name==='NotAllowedError'?'NotAllowedError':'transient';
     video.dataset.mcVideoState=this.blockedReason;this.dataset.mcVideoState=this.blockedReason;
     const count=this.retryCounts.get(video)||0;
     if(this.blockedReason==='transient'&&count<2&&(!video.error||video.error.code===2)){
      this.retryCounts.set(video,count+1);clearTimeout(this.retryTimer);
      this.retryTimer=setTimeout(()=>this.recover(),1500*(count+1));
     }
    }
    this.paint(video);
   }).finally(()=>{if(this.starting===video)this.starting=null;});
  }
  disconnectedCallback() {clearTimeout(this.retryTimer);this.pauseAll();this.events?.abort();this.observer?.disconnect();this.posterObserver?.disconnect();this.events=null;}
 });
}

  } catch(e) { console.error(e); }
})();
})();
